"use strict";

exports.__esModule = true;
var _CommonValidators = require("./CommonValidators");
Object.keys(_CommonValidators).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommonValidators[key]) return;
  exports[key] = _CommonValidators[key];
});
var _ClassifyValidators = require("./ClassifyValidators");
Object.keys(_ClassifyValidators).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassifyValidators[key]) return;
  exports[key] = _ClassifyValidators[key];
});